export default class CustomerPhoneNumber {
    public id: string;
    public userId: number;
    public phoneNumber: string;

    constructor(json: any) {
        this.id = json.id;
        this.userId = json.userId;
        this.phoneNumber = json.phoneNumber;
    }

    public toString(): string {
        return this.phoneNumber;
    }
}
